import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login'
import Register from '@/views/register'

// 路由懒加载，写成函数的格式 webpack打包的时候，
// 看到这个标识就不会不加载这个js文件
// webpackChunkName 用来 指明 打包后 生成的文件名

const Activity = () => import(/* webpackChunkName: 'Activity' */ '@/views/Activity/index')
const ActivityProduct = () => import(/* webpackChunkName: 'ActivityProduct' */ '@/views/Activity/ActivityProduct')
const PointsInfo = () => import(/* webpackChunkName: 'PointsInfo' */ '@/views/Activity/PointsInfo')
const PointsDetail = () => import(/* webpackChunkName: 'PointsDetail' */ '@/views/Activity/PointsDetail')
const CodeInfo = () => import(/* webpackChunkName: 'CodeInfo' */ '@/views/Activity/CodeInfo')
const ShareCommunity = () => import(/* webpackChunkName: 'ShareCommunity' */ '@/views/Activity/shareCommunity')

Vue.use(VueRouter)

const routes = [
  {
    // 根路径 的 重定向
    path: '/',
    redirect: '/login'// 重定向
  },
  {
    // 登录页
    path: '/login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    // 登录页
    path: '/register',
    component: Register,
    meta: {
      title: 'Register'
    }
  },
  {
    path: '/activity',
    component: Activity,
    meta: {
      title: 'Activity'
    }
  },
  {
    path: '/activity/activityProduct',
    component: ActivityProduct,
    meta: {
      title: 'Activity Product'
    }
  },
  {
    path: '/activity/pointsInfo',
    component: PointsInfo,
    meta: {
      title: 'Points Info'
    }
  },
  {
    path: '/activity/pointsDetail',
    component: PointsDetail,
    meta: {
      title: 'Points Detail'
    }
  },
  {
    path: '/activity/codeInfo',
    component: CodeInfo,
    meta: {
      title: 'Code Info'
    }
  },
  {
    path: '/activity/shareCommunity',
    component: ShareCommunity,
    meta: {
      title: 'Share Community'
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0 })
})

router.afterEach((to) => {
  // if (typeof window.gtag === 'function') {
  //   gtag('config', 'G-XTF0LRE0J4', {
  //     page_path: to.fullPath,
  //     page_title: to.meta.title || 'untitled_page'
  //   })
  // } else {
  //   console.log('gtag not loaded, skipping analytics tracking')
  // }
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title ? to.meta.title : 'Promotion'
  next()
})

// 路由重复跳转问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
